// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"AddOnCheckbox_checkbox__wKM2D","icon":"AddOnCheckbox_icon__LY8uC","checkboxComponent":"AddOnCheckbox_checkboxComponent__3zdKd"};